import { render, staticRenderFns } from "./configNotas.vue?vue&type=template&id=053e6cb9&scoped=true&"
import script from "./configNotas.vue?vue&type=script&lang=js&"
export * from "./configNotas.vue?vue&type=script&lang=js&"
import style0 from "./configNotas.vue?vue&type=style&index=0&id=053e6cb9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053e6cb9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VIcon,VProgressCircular,VRow,VSwitch,VTooltip})
